module.exports = require("@angular/material/dialog");


//////////////////
// WEBPACK FOOTER
// external "@angular/material/dialog"
// module id = 1003
// module chunks = 0